
import { Component, Vue } from 'vue-property-decorator'
import faqData from '@/data/faq.json'
import { FAQ_SCENES } from '@/types/faq'
import type { FaqCategory, FaqData } from '@/types/faq'
import { filterFaqGroupsByScene, toFaqCategories } from '@/utils/faq'

@Component
export default class HelpBlock extends Vue {
  private categories: readonly FaqCategory[] = toFaqCategories(
    filterFaqGroupsByScene(
      faqData as unknown as FaqData,
      FAQ_SCENES.FAQ,
    ),
  )

  private goToCategory(categoryId: string): void {
    this.$router.push({
      name: 'faq',
      hash: `#${categoryId}`,
    }).catch(error => {
      if (error && error.name !== 'NavigationDuplicated') {
        throw error
      }
    })
  }
}
